<template>
    <div>

			<expandable-area title="API Key" :tag="!!appConfig['api_key']?'':`(not set)`" name="TaxJar.ApiKey" >
				<div class="margin-t-25 ">
					<div class="layout-row flex-center">
						<input-field class="flex margin-r-15" :flat="!ApiChanged" v-model="appConfig['api_key']"
						             placeholder="Your TaxJar API Key..."
						             @input="ApiChanged=true"/>

						<v-button class="flex-none" v-if="ApiChanged" slim :loading="loading"
						          @click="updateApiKey()" >
							Save
						</v-button>

					</div>
				</div>
			</expandable-area>

	    <expandable-area title="Products' tax codes" tag="" name="TaxJar.TaxCodes" >
		    <div class="margin-t-25 ">

			    <div class="tax-codes-header layout-row">
				    <span class="product">Product</span>
				    <span></span>
				    <span class="tax-code">Tax Code/Category</span>
			    </div>
			    <product-tax-code-entry v-for="(taxCode,index) in taxCodes" :key="'taxcode_'+index"
			                            @change="change" :tax-code="taxCode"
			                            :funnel-id="funnel.id" :api-key="appConfig['api_key']" :app-id="appId" />
		    </div>
	    </expandable-area>

	    <expandable-area title="Settings" tag="(optional)" name="TaxJar.Settings" >
		    <div class="margin-t-25 ">
			    <h3 class="layout-row">
				    From address <info-icon>This is usually your business address,
				    You can also setup a Nexus address within your TaxJar account</info-icon>
			    </h3>
			    <div class="margin-t-10">
				    <input-field placeholder="Address" v-model="appConfig['from_address']" />
				    <div class="layout-row margin-t-10">
					    <input-field placeholder="Zip/Postal code" v-model="appConfig['from_zip']" />
					    <input-field placeholder="City" v-model="appConfig['from_city']" />
					    <input-field placeholder="State" v-model="appConfig['from_state']" />
				    </div>
				    <select-field class="margin-t-10" caption="Country" placeholder="Country" :options="countries" label="text"
				                  searchable clearable v-model="appConfig['from_country']" />
			    </div>

			    <h3 class="margin-t-25">
				    Tax summary settings
			    </h3>
			    <div class="margin-t-15">
				    <v-switch  label="Show tax entry when tax rate is 0%"
				              v-model="appConfig['always_show_entry']" :value="appConfig['always_show_entry']"/>

				    <input-field class="margin-t-25" :placeholder="`eg. Sales tax ({{RATE}})`" v-model="appConfig['tax_entry_text']"
				                 label="Sales tax text format"
				                 :info="`You can use <b>{{RATE}}</b> as a placeholder for the actual calculated rate.`" />
			    </div>
		    </div>
	    </expandable-area>

	    <div class=" alert_box orange">
		    <div class="icon">
			    <inline-svg :src="require('@/assets/img/alert_icon_yellow.svg')" />
		    </div>
		    <span>
		    Got any feedback or want to report any issues? <b class="let-us-know" @click="openIntercom">Let us know!</b>
		    </span>
	    </div>
    </div>
</template>

<script>
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import ExpandableArea from "@/components/base/expandable-area";
import API from '@/api'
import ProductTaxCodeEntry from "@/views/funnels/apps/funnel-apps/taxjar/product-tax-code-entry";
import SelectField from "@/components/base/select-field";
import countries from "@/helpers/countries";
import InfoIcon from "@/components/base/info-icon";
import VSwitch from "@/components/base/v-switch";

export default {
    name: 'TaxJarSettings',
    props: ['dataBufferObject', 'funnel', 'appId', 'userApp'],
		mixins:[API],
    components: {
	    VSwitch,
	    InfoIcon,
	    SelectField,
	    ProductTaxCodeEntry,
	    ExpandableArea,
	    InputField,
	    VButton,
    },
    computed: {
    },
    data() {
        return {
        	countries: countries,
        	loading: false,
        	products: [],
	        taxCodes: [],
          appConfig: {
        		api_key: "",
	          taxCodes: [
	          		{productId: '',taxCode:''}
	          ]
          },
	        ApiChanged: false,
        }
    },
    methods: {
    	findProductTaxCode(p) {
    		let x = this.appConfig.taxCodes.find(x => x.productId===p.id);
    		if (!x) return '';
    		return x.taxCode
	    },
	    change(product, value) {
    		// re-generate all taxCodes list.
		    this.appConfig.taxCodes = [];
		    this.taxCodes.forEach(x => {
		    	this.appConfig.taxCodes.push({productId:x.productId,taxCode:x.taxCode})
		    })

		    this.$emit('update', this.appConfig.taxCodes, 'taxCodes');
	    },
    	updateApiKey() {
		    this.$emit('update', this.appConfig['api_key'], 'api_key');
		    this.ApiChanged = false;
	    },
	    openIntercom() {
		    window.Intercom("showNewMessage", "TaxJar app feedback:\n");
	    },
	    async load(){
	    	try {
	    		this.loading = true;

			    this.products = await this.api.funnels.getProducts(this.funnel.id, 'wfunnels')
			    this.taxCodes = [];
			    this.products.forEach(p => {
			    	let tc = this.findProductTaxCode(p) // find existing tax code if any or ''
				    this.taxCodes.push({productId:p.id, taxCode:tc, productName:p.name, imageUrl:p.image_url});
			    })

		    } catch (e) {
			    this.$error(e)
		    } finally {
			    this.loading = false;
		    }
	    },
    },
	mounted() {
		this.load();
	},
	created(){
        if(this.dataBufferObject) {
          this.appConfig = this.dataBufferObject;
	        if (!this.appConfig.taxCodes) this.$set(this.appConfig, "taxCodes", []);
        } else {
            this.appConfig = JSON.parse(`{"api_key":"","taxCodes":[],"tax_entry_text":"Sales tax ({{RATE}})", "always_show_entry":false}`)
        }
 	}
}
</script>
<style lang="scss" scoped>
.api-key {
	border-radius: 5px;
	//border: 1px dashed grey;
	padding: 5px;
}
.tax-codes-header {
	display: flex;
	flex-direction: row;
	flex: 1;
	align-items: center;
	margin-bottom: 10px;
	font-weight: 600;
	color: $grey;
	.product {
		width: 60%;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-left: 10px;
	}
	.tax-code {
		width: 40%;
		margin-left: 10px;
	}
}
.let-us-know {
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
}
.events-wrapper {
	margin-top: 25px;
	h3 {
		font-weight: 600;
		font-size: 16px;
	}
	.events-list {
		margin: 10px 10px 10px 30px;
	}
}
.icon-pixel {
	width: 41px;
	height: 41px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	border-radius: 6px;
	margin-left: 5px;
	border: 1px solid #C5C7D2;
	cursor: pointer;
	font-weight: 700;
	transition: all 0.3s ease;
	padding: 4px;
}
.tag {
	margin: 0;
}
.pixels_root {
	margin-top: 15px;
}
</style>
